export default "__VITE_ASSET__C9OEEL9w__"